import styled, { css } from 'styled-components'

interface ButtonProps {
  readonly height: number
  readonly width: number
  onClick?: any
  borderRadius: number
  src: string
}

export const AvatarStyle = {
  Container: styled.div<ButtonProps>`
    cursor: pointer;
    border-radius: ${({ borderRadius }) => `${borderRadius}px`};
    overflow: hidden;
    align-items: center;
    min-width: ${({ width }) => `${width + 5}px`};
    min-height: ${({ height }) => `${height + 5}px`};
    max-width: ${({ width }) => `${width + 5}px`};
    max-height: ${({ height }) => `${height + 5}px`};
    justify-content: center;
    ${({ src }) => css`
      background-image: url(${src});
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    `}
  `,
}
